module.exports = __webpack_public_path__ + "static/content-magento-2-1a5aa272272195ea4e85c708cb597c4f.jpg";